module.exports = __webpack_public_path__ + "media/images/pic/saska/hero_saska_teen-d05d29b5cb863e190125d05b4f1c9c0b.svg";